import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateSubtitlesResourceMutation = createMutationHook(
  MembershipsCreatorApiClient.createSubtitlesResource,
  {
    mutationKey: ['createSubtitlesResource'],
  },
)
